import { useMerchant } from "../hooks/useMerchant";
import PopupModal from "./PopupModal";
import payoutsUpsell from "../assets/payoutsUpsell.png";

const PayoutsPopUpModal = (): JSX.Element => {
  const { merchant } = useMerchant();
  if (!merchant || !merchant.payoutsPromoActive || merchant.payoutsConfig)
    return <></>;

  return (
    <PopupModal
      img={payoutsUpsell}
      redirectUrl="https://wa.me/573126202787"
      redirectOnBlank
      localStorageKey="payoutsUpsellModal"
      displayOncePer="month"
    />
  );
};
export default PayoutsPopUpModal;
